import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CustomPagesSection } from '~/components/AgreementStudioPage/AgreementStudioModal/CustomPagesSection/CustomPagesSection';
export const EditAgreementCustomPages = (param)=>{
    let { relationship, onUploadingChange, sectionRef, submittedPageIds } = param;
    const { control, getValues, setValue } = useFormContext();
    const customPages = useWatch({
        control,
        name: 'customPages'
    });
    const { originalPagesById, existingPageIds, hiddenPageIds } = useMemo(()=>{
        var _relationship_customPages;
        const all = (_relationship_customPages = relationship.customPages) !== null && _relationship_customPages !== void 0 ? _relationship_customPages : [];
        const hidden = all.filter((p)=>!(p.displayScope === 'proposalAndAgreement' && p.type !== 'video'));
        return {
            originalPagesById: new Map(all.map((p)=>[
                    p.id,
                    p
                ])),
            existingPageIds: new Set(all.map((p)=>p.id)),
            hiddenPageIds: new Set(hidden.map((p)=>p.id))
        };
    }, [
        relationship.customPages
    ]);
    const getSourceId = useCallback(()=>relationship.id, [
        relationship.id
    ]);
    const setCustomPages = useCallback((updater)=>{
        const current = getValues('customPages');
        const next = typeof updater === 'function' ? updater(current) : updater;
        if (next === current) return;
        setValue('customPages', next, {
            shouldDirty: true,
            shouldValidate: true
        });
    }, [
        getValues,
        setValue
    ]);
    const handleRevertEditedPage = useCallback((pageId)=>{
        const original = originalPagesById.get(pageId);
        if (original == null) return;
        setCustomPages((prev)=>prev.map((p)=>p.id === pageId ? original : p));
    }, [
        originalPagesById,
        setCustomPages
    ]);
    const amendmentMode = useMemo(()=>({
            existingPageIds,
            hiddenPageIds,
            originalPagesById,
            onRevertEditedPage: handleRevertEditedPage
        }), [
        existingPageIds,
        hiddenPageIds,
        originalPagesById,
        handleRevertEditedPage
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: sectionRef,
        "data-testid": "edit-agr-custom-pages-section",
        children: /*#__PURE__*/ _jsx(CustomPagesSection, {
            customPages: customPages,
            setCustomPages: setCustomPages,
            submittedPageIds: submittedPageIds,
            getSourceId: getSourceId,
            onUploadingChange: onUploadingChange,
            amendmentMode: amendmentMode
        })
    });
};
